import type { TicketCategory, CategoryGroup } from './types';

export function buildCategoryGroups(
  categories: TicketCategory[],
): CategoryGroup[] {
  const parents = categories.filter((c) => !c.parentId);
  const children = categories.filter((c) => c.parentId);

  const childrenByParent: Record<string, TicketCategory[]> = {};
  for (const child of children) {
    const pid = child.parentId;
    (childrenByParent[pid] ||= []).push(child);
  }

  return parents.map((p) => ({
    parent: p,
    children: childrenByParent[p.id] || [],
  }));
}

export function extractGameCategories(
  groups: CategoryGroup[],
): TicketCategory[] {
  const norm = (s?: string) => (s ? s.trim().toLowerCase() : '');
  const gamesParent = groups.find(
    (g) =>
      norm(g.parent.name) === 'games' || norm(g.parent.locoKey) === 'games',
  );
  return gamesParent ? gamesParent.children : [];
}

export function extractUncategorizedCategories(
  groups: CategoryGroup[],
): TicketCategory[] {
  const norm = (s?: string) => (s ? s.trim().toLowerCase() : '');
  const uncatParent = groups.find(
    (g) =>
      norm(g.parent.name) === 'uncategorized' ||
      norm(g.parent.locoKey) === 'uncategorized',
  );
  return uncatParent ? uncatParent.children : [];
}
